module.exports = __webpack_public_path__ + "static/media/icon-arqueta.9d01436a.svg";